import {
    SET_PLAYING_VIDEO_W, SET_PENDING_WORKOUT, SET_NEXT_WORKOUTS, SET_TRENDING_WORKOUT, SET_WEEK_WORKOUTS,
    SET_GROUPED_WORKOUTS, SET_CURRENT_WATCHED,
} from "./types";

const initialState = {
    workouts: [],
    playing: {},
    pendingWorkout: null,
    trendingWorkouts: [],
    nextWorkouts: null,
    weekWorkouts: [],
    groupedWorkouts: {

    },

    currentWatched: 0,
};

export default function (state = initialState, action) {

    switch (action.type) {

        case SET_GROUPED_WORKOUTS:
            return {
                ...state,
                groupedWorkouts: action.data
            }

        case SET_PLAYING_VIDEO_W:
            return {
                ...state,
                playing: action.data
            }

        case SET_PENDING_WORKOUT:
            return {
                ...state,
                pendingWorkout: action.data
            }

        case SET_NEXT_WORKOUTS:
            return {
                ...state,
                nextWorkouts: action.data
            }

        case SET_TRENDING_WORKOUT:
            return {
                ...state,
                trendingWorkouts: [...action.data]
            }

        case SET_WEEK_WORKOUTS:
            return {
                ...state,
                weekWorkouts: [...action.data]
            }


        case SET_CURRENT_WATCHED:
            return {
                ...state,
                currentWatched: state.currentWatched + 1
            }

        default:
            return state;
    }
}